import rnCore from 'rhino/src/core/core.module';
import rnApplication from 'rhino/src/components/application/application.module';
import * as rnSession from './session.service';

export default angular.module('rhino.components.session', [
  'ngCookies',
  rnApplication,
  rnCore,
])
  .service(rnSession.name, rnSession.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/session/session.module.js